import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
    MatIconRegistry, MatButtonModule, MatCheckboxModule,
    MatCardModule, MatToolbarModule, MatSidenavModule,
    MatIconModule, MatInputModule, MatRadioModule,
    MatFormFieldModule, MatAutocompleteModule, MatSelectModule,
    MatDatepickerModule, MatNativeDateModule,
    MatTabsModule, MatDialogModule, MatDividerModule,
    MatTooltipModule
} from '@angular/material';

import { MatTableModule } from '@angular/material/table';

import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
    imports: [
        FlexLayoutModule,
        MatButtonModule, MatCheckboxModule,
        MatCardModule, MatToolbarModule, MatSidenavModule,
        MatIconModule, MatInputModule, MatRadioModule,
        MatFormFieldModule, MatAutocompleteModule, MatSelectModule,
        MatDatepickerModule, MatNativeDateModule,
        MatTabsModule, MatDialogModule, MatDividerModule, MatTableModule,
        MatTooltipModule
    ],
    exports: [FlexLayoutModule,
        MatButtonModule, MatCheckboxModule,
        MatCardModule, MatToolbarModule, MatSidenavModule,
        MatIconModule, MatInputModule, MatRadioModule,
        MatFormFieldModule, MatAutocompleteModule, MatSelectModule,
        MatDatepickerModule, MatNativeDateModule,
        MatTabsModule, MatDialogModule, MatDividerModule, MatTableModule,
        MatTooltipModule]
})

export class SharedMaterialAndFlexModule {
    constructor(matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer) {
        matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl('./mdi.svg'));
    }
}



// WEBPACK FOOTER //
// ./src/app/components/shared-material-flex.module.ts